import 'react';
import { jsx } from '@emotion/react';
import { TextareaField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../components/FormContent.js';
import { InspectorFormProvider } from '../../components/InspectorFormProvider.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1xat37b",
  styles: "textarea{min-height:240px;}"
} : {
  name: "9bv7r0-HTMLTemplateInspector",
  styles: "textarea{min-height:240px;};label:HTMLTemplateInspector;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhUTUxUZW1wbGF0ZS5JbnNwZWN0b3IudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9Cd0IiLCJmaWxlIjoiSFRNTFRlbXBsYXRlLkluc3BlY3Rvci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgUmVhY3RFbGVtZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgVGV4dGFyZWFGaWVsZCB9IGZyb20gJ0BidWNrZXRwbGFjZS9jb21tZXJjZS1hZG1pbi11aSc7XG5cbmltcG9ydCB7IEZvcm1Db250ZW50LCBJbnNwZWN0b3JGb3JtUHJvdmlkZXIgfSBmcm9tICcuLi8uLi9jb21wb25lbnRzJztcbmltcG9ydCB7IERvY3VtZW50SW5zcGVjdG9yUHJvcHMgfSBmcm9tICcuLi8uLi90eXBlcyc7XG5pbXBvcnQgeyBIVE1MVGVtcGxhdGVQcm9wcyB9IGZyb20gJy4vSFRNTFRlbXBsYXRlJztcblxuZXhwb3J0IGZ1bmN0aW9uIEhUTUxUZW1wbGF0ZUluc3BlY3Rvcih7XG4gIHZhbHVlLFxuICBvbkNoYW5nZSxcbn06IERvY3VtZW50SW5zcGVjdG9yUHJvcHM8SFRNTFRlbXBsYXRlUHJvcHM+KTogUmVhY3RFbGVtZW50IHtcbiAgcmV0dXJuIChcbiAgICA8SW5zcGVjdG9yRm9ybVByb3ZpZGVyIHZhbHVlPXt2YWx1ZX0gb25DaGFuZ2U9e29uQ2hhbmdlfT5cbiAgICAgIDxGb3JtQ29udGVudCBoZWFkZXI9XCLrgrTsmqlcIiBkaXJlY3Rpb249XCJWRVJUSUNBTFwiPlxuICAgICAgICA8VGV4dGFyZWFGaWVsZFxuICAgICAgICAgIG5hbWU9XCJjb250ZW50c1wiXG4gICAgICAgICAgd2lkdGg9XCIxMDAlXCJcbiAgICAgICAgICBwbGFjZWhvbGRlcj1cIkhUTUzroZwg65CcIOuCtOyaqeydhCDsnoXroKXtlbTso7zshLjsmpQuXCJcbiAgICAgICAgICBhdXRvSGVpZ2h0XG4gICAgICAgICAgY3VzdG9tQ3NzPXtjc3NgXG4gICAgICAgICAgIHRleHRhcmVhIHtcbiAgICAgICAgICAgICAgbWluLWhlaWdodDogMjQwcHg7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgYH1cbiAgICAgICAgLz5cbiAgICAgIDwvRm9ybUNvbnRlbnQ+XG4gICAgPC9JbnNwZWN0b3JGb3JtUHJvdmlkZXI+XG4gICk7XG59XG5cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function HTMLTemplateInspector(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(FormContent, {
    header: "\uB0B4\uC6A9",
    direction: "VERTICAL"
  }, jsx(TextareaField, {
    name: "contents",
    width: "100%",
    placeholder: "HTML\uB85C \uB41C \uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
    autoHeight: true,
    customCss: _ref
  })));
}

export { HTMLTemplateInspector };
//# sourceMappingURL=HTMLTemplate.Inspector.js.map
